module.exports = __webpack_public_path__ + "img/LT112041073.b7dab79b.png";